<template>
  <div class="page-system-set xc-page-sandwich">
    <div class="xc-page-main">
      <div class="xc-breadcrumb">
        <router-link :to="$config.adminPath + '/system/set'">系统管理</router-link>
        <a>基础设置</a>
      </div>
      <div class="xc-row xc-s-flex">
        <div class="xc-card">
          <div class="xc-card-header">
            <div class="xc-card-title">基础设置</div>
          </div>
          <div class="xc-card-content">
            <form ref="form">
              <div class="xc-info" v-for="(group,key,index) in configOptions" :key="index">
                <div class="xc-info-title">{{key}}</div>
                <div class="xc-info-content">
                  <div class="xc-form-inline" v-for="(row,index) in group" :key="index">
                    <xc-form-item
                      :class="{'game-style':item.type == 'game_url'}"
                      :label="item.desc"
                      required
                      :error="errors.first(item.type)"
                      v-for="(item,index) in row"
                      :key="index"
                      class="position-upload"
                    >
                      <template v-if="item.type=='boot_time_diff'">
                        <select
                          :name="item.type"
                          v-model="sysconfig[item.type].value"
                          class="xc-select"
                          v-validate="'required'"
                          :data-vv-as="item.desc"
                        >
                          <option value>请选择</option>
                          <option value="true">区分周末</option>
                          <option value="false">不区分周末</option>
                        </select>
                      </template>
                      <template v-else-if="item.type=='need_auth_program'">
                        <select
                          :name="item.type"
                          v-model="sysconfig[item.type].value"
                          class="xc-select"
                          v-validate="'required'"
                          :data-vv-as="item.desc"
                        >
                          <option value>请选择</option>
                          <option value="true">开启(注意设置权限)</option>
                          <option value="false">关闭</option>
                        </select>
                      </template>
                      <!--只能是数值类型-->
                      <template v-else-if="item.type=='file_group_quantity'">
                        <input
                          type="text"
                          class="xc-input"
                          :name="item.type"
                          v-validate="'required|numeric'"
                          :data-vv-as="item.desc"
                          v-model="sysconfig[item.type].value"
                        />
                      </template>

                      <!-- 节目上下线提醒 -->
                      <template v-else-if="item.type=='program_online_alarm'">
                        <select
                          :name="item.type"
                          v-model="sysconfig[item.type].value"
                          class="xc-select"
                          v-validate="'required'"
                          :data-vv-as="item.desc"
                        >
                          <option value="">请选择</option>
                          <option value="3">3天</option>
                          <option value="5">5天</option>
                          <option value="7">7天</option>
                        </select>
                      </template>
                      <template v-else-if="item.type=='program_offline_alarm'">
                        <select
                          :name="item.type"
                          v-model="sysconfig[item.type].value"
                          class="xc-select"
                          v-validate="'required'"
                          :data-vv-as="item.desc"
                        >
                          <option value="">请选择</option>
                          <option value="3">3天</option>
                          <option value="5">5天</option>
                          <option value="7">7天</option>
                          <option value="15">15天</option>
                        </select>
                      </template>

                      <!-- 通用的 -->
                      <template v-else-if="item.accept=='Boolean'">
                        <select
                          :name="item.type"
                          v-model="sysconfig[item.type].value"
                          class="xc-select"
                          v-validate="'required'"
                          :data-vv-as="item.desc"
                        >
                          <option value>请选择</option>
                          <option value="true">是</option>
                          <option value="false">否</option>
                        </select>
                      </template>

                      <template v-else-if="item.accept=='File' && item.type !='breathing_music' && item.type !='standby_image'">
                        <xc-upload
                          :fileList.sync="sysconfig[item.type].value"
                          type="3"
                          accept="image/*"
                          :url="uploadUrl"
                          :inputName="item.type"
                          data-name="url"
                        />
                      </template>
                      <template v-else-if="item.accept=='File' && item.type =='breathing_music'">
                        <xc-upload1
                            :fileList.sync="videoFiles"
                            type="0"
                            accept=".mp3"
                            :url="uploadUrl"
                            :multiple="true"
                            :beforeUpload="beforeUpload"
                        />
                        <input
                            type="file"
                            class="file-input"
                            id="file-selector"
                            size="small"
                            accept=".mp3"
                            @change="changeFile"
                            @del="del"
                        />
                      </template>
                      <template v-else-if="item.accept=='File' && item.type =='standby_image'">
                        <div  style="display: flex;">
                          <xc-upload
                            :fileList.sync="standbyImageList[0]"
                            type="3"
                            accept="image/*"
                            :url="uploadUrl"
                            :inputName="item.type"
                            data-name="url"
                          />
                          <xc-upload
                            :fileList.sync="standbyImageList[1]"
                            type="3"
                            accept="image/*"
                            :url="uploadUrl"
                            :inputName="item.type"
                            data-name="url"
                          />
                          <xc-upload
                            :fileList.sync="standbyImageList[2]"
                            type="3"
                            accept="image/*"
                            :url="uploadUrl"
                            :inputName="item.type"
                            data-name="url"
                          />
                        </div>
                       
                      </template>
                      <!--只能是数值类型-->
                      <template v-else-if="item.accept=='Number'">
                        <input
                          type="text"
                          class="xc-input"
                          :name="item.type"
                          v-validate="'required|number'"
                          :data-vv-as="item.desc"
                          v-model="sysconfig[item.type].value"
                        />
                      </template>

                      <template v-else>
                        <input
                          type="text"
                          maxlength="30"
                          class="xc-input"
                          :name="item.type"
                          v-validate="'required'"
                          :data-vv-as="item.desc"
                          v-model="sysconfig[item.type].value"
                        />
                      </template>
                    </xc-form-item>
                  </div>
                </div>
              </div>
              <!-- <div class="xc-info">
                <div class="xc-info-title">故障类型设置</div>
                <div class="xc-info-content">
                  <div class="xc-form-inline">
                    <div class="xc-form-item fault">
                      <div class="xc-form-item-label fault-wrap">
                        <div class="type-title">已有故障类型</div>
                      </div>
                      <div class="xc-form-inline but-list">
                        <div class="fault-type" v-for="(item, index) in breakdownTypeList" :key="index">
                          <div class="fault-type-left">{{ item.breakdownType }}</div>
                          <div class="fault-type-right" @click="del(index, item.id)">x</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="xc-form-inline">
                    <div class="xc-form-item">
                      <div class="xc-form-item-label" style="width:90px;">
                        <label>新增故障类型</label>
                      </div>
                      <div class="xc-form-item-content">
                        <input type="text" class="xc-input" v-model="faultType" />
                        <a
                          class="xc-btn xc-btn-primary"
                          style="margin-left:25px;"
                          @click.prevent="add"
                        >添加</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->
              
              <div class="xc-info">
                <div class="xc-info-title">空刊设置</div>
                <div class="xc-info-content">
                  <div class="xc-form-inline">
                    <div class="xc-form-item">
                      <div class="xc-form-item-label" style="width:90px;line-height:40px">
                        <label>选择时间</label>
                      </div>
                      <div class="xc-form-item-content select-style">
                        <el-cascader
                          v-model="value"
                          :options="options"
                          placeholder="请选择时间"
                          @change="handleChange">
                        </el-cascader>
                      </div>
                    </div>
                    
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="xc-page-footer" v-if="userModule && userModule.button['/ckips/sysconfig/batchupdate']">
      <div class="xc-btn-group">
        <button type="button" class="xc-btn xc-btn-primary" @click="submit">保存</button>
      </div>
    </div>
  </div>
</template>

<script>
import "@/libs/vee-validate";
import sysconfigApi from "@/api/sysconfig";
import "@/utils/form-format";
import _ from "lodash";
import { mapState, mapActions } from "vuex";
import { uploadFile } from "@/utils/uploadfile";

export default {
  name: "systemSet",
  computed: {
    ...mapState(["userModule"])
  },
  data() {
    return {
      sysconfig: {},
      configOptions: {},
      uploadUrl: "/uploadfile",

      // 已有故障类型类别
      breakdownTypeList: [],
      //添加故障类型
      faultType: null,
      videoFiles: [],
      standbyImageList:[], // 空闲状态图片
      //element-ui 中的 Cascader的数据
      selectTime:[{
        value:"0",
        label:"0小时",
      },{
        value:"1",
        label:"1小时",
      },{
        value:"2",
        label:"2小时",
      },{
        value:"3",
        label:"3小时",
      },{
        value:"4",
        label:"4小时",
      },{
        value:"5",
        label:"5小时",
      },{
        value:"6",
        label:"6小时",
      },{
        value:"7",
        label:"7小时",
      },{
        value:"8",
        label:"8小时",
      },{
        value:"9",
        label:"9小时",
      },{
        value:"10",
        label:"10小时",
      },{
        value:"11",
        label:"11小时",
      },{
        value:"12",
        label:"12小时",
      },{
        value:"13",
        label:"13小时",
      },{
        value:"14",
        label:"14小时",
      },{
        value:"15",
        label:"15小时",
      },{
        value:"16",
        label:"16小时",
      },{
        value:"17",
        label:"17小时",
      },{
        value:"18",
        label:"18小时",
      },{
        value:"19",
        label:"19小时",
      },{
        value:"20",
        label:"20小时",
      },{
        value:"21",
        label:"21小时",
      },{
        value:"22",
        label:"22小时",
      },{
        value:"23",
        label:"23小时",
      }],
      value:[],
      options:[{
        value:"1",
        label:"1天",
        children:"",
      },{
        value:"2",
        label:"2天",
        children:"",
      },{
        value:"3",
        label:"3天",
        children:"",
      },{
        value:"4",
        label:"4天",
        children:"",
      },{
        value:"5",
        label:"5天",
        children:"",
      },{
        value:"6",
        label:"6天",
        children:"",
      },{
        value:"7",
        label:"7天",
        children:"",
      }],
      //后台反馈的空刊的时间
      time:null,
      //设置空刊时间的小时数
      hours:null,
    };
  },
  async created() {
    // 获取系统设置
    sysconfigApi.getConfig().then(ret => {
      const sysconfig = {};
      const configOptions = {
        素材内容配置: [],
        时间设置: [],
        其他设置: [],
        节目提醒: []
      };
      // 将数据转换成数组
      ret.data.forEach(v => {
        if (v.accept == "File") {
          if (v.type == "standby_image"){
            this.standbyImageList = []
            let imgList = v.value.split(",");
            imgList.forEach(res=>{
              this.standbyImageList.push([{url:res}])
            })
          } 
          if (v.type == "breathing_music"){
            this.videoFiles.push({url:v.value,name:'调息音乐.mp3'})
          }
          v.value = [{url: v.value}];
        }
       
        if (v.group == "materials") {
          configOptions["素材内容配置"].push(v);
        } else if (v.group == "timer") {
          configOptions["时间设置"].push(v);
        } else if (v.group == "other") {
          if(v.type !== "device_no_program_countdown_time")
          configOptions["其他设置"].push(v);
        } else if (v.group == "alarm"){
          configOptions["节目提醒"].push(v);
        }

        sysconfig[v.type] = v;
      });

      // 拆分块
      Object.keys(configOptions).forEach(key => {
        configOptions[key] = _.chunk(configOptions[key], 2);
      });

      this.sysconfig = sysconfig;
      this.configOptions = configOptions;
      //设置空刊设置的默认数据
      this.time = sysconfig.device_no_program_countdown_time.value;
      this.getDate()
    });

    // this.getFault();
  },
  mounted(){
    //用element-ui 把小时项添加到各个选项中。
    this.options.map((item) => {
      item.children = this.selectTime;
    });
  },
  watch: {},
  methods: {
    // getFault() {
    //   // 故障类型设置
    //   sysconfigApi.getFault().then(ret => {
    //     this.breakdownTypeList = ret.data;
    //   });
    // },

    // 保存
    submit: function() {
      this.$validator.validateAll().then(validate => {
        if (validate) {
          const newConfig = [];
          if(this.hours != null){
            this.sysconfig.device_no_program_countdown_time.value = this.hours;
          }
          for (const key in this.sysconfig) {
            const item = {
              ...this.sysconfig[key]
            };
            if (item.accept == "File") {
             //空闲状态多图上传
              if (item.type == "standby_image"){
                let imgList = [];
                this.standbyImageList.forEach(res=>{
                  if(res.length > 0 && res[0].url !== ''){
                    imgList.push(res[0].url)
                  }
                })
                item.value = imgList.join(",");
              } else {
                 item.value = item.value.map(v => {return v.url;}).join(",");
              }
            }
            if (item.type == "breathing_music"){
              item.value = this.videoFiles[0].url;
            }

            newConfig.push({
              type: item.type,
              value: item.value
            });
          }

          sysconfigApi
            .updateConfig({
              configs: JSON.stringify(newConfig)
            })
            .then(success => {
              this.$message.success("操作成功");
              localStorage.removeItem("globalConfig");
              this.$store.dispatch("getConfig");
            });
          return;
        }
      });
    },

    //增加故障类型和删除故障类型

    // add: function() {
    //   if (this.faultType) {
    //     sysconfigApi
    //       .addFault({
    //         name: this.faultType
    //       })
    //       .then(ret => {
    //         this.$message.success("操作成功");
    //         this.faultType = null;
    //         this.getFault();
    //       });
    //   }
    // },
    // del(index, id) {
    //   sysconfigApi.delFault({id}).then(success => {
    //     this.$message.success("删除成功");

    //     this.breakdownTypeList.splice(index, 1);
    //   });
    // },
    //element-ui中的 cascader 返回的值
    handleChange(value){
      this.hours = value[0]*24 + value[1]*1;
    },
    getDate(){
      this.value = [`${parseInt(this.time/24)}`,`${this.time%24}`];
    },
    beforeUpload(file) {
      if (!this.sysConfig.upload_max_video_size) {
          this.$message.error("上传配置获取识别，请稍后重试");
          return false;
      }

      const maxSize = this.sysConfig.upload_max_video_size.value * 1024 * 1024;
      const passSuffix = this.sysConfig.pass_video_suffix.value.split(",");

      if (file.size > maxSize) {
          this.$message.error(
          "音乐大小不能超过" + this.sysConfig.upload_max_video_size.value + "MB"
          );
          return false;
      }

      const suffixAry = file.name.split(".");
      if (suffixAry.length == 0) {
          this.$message.error(
          "文件格式不正确，请上传" + passSuffix.join(",") + "格式文件"
          );
          return false;
      }

      // 判断是否允许的格式
      const allowType = passSuffix.some((item) => {
          return suffixAry[suffixAry.length - 1] == item;
      });

      // 不允许的文件格式
      if (!allowType) {
          this.$message.error(
          "文件格式不正确，请上传" + passSuffix.join(",") + "格式文件"
          );
          return false;
      }
  },
    changeFile(event) {
        let file = event.target.files[0];
        if (!file) return;
        this.loading = true;
        this.cosUploadFile(file);
    },
    // 通过腾讯云 cos-js-sdk-v5 上传
  cosUploadFile(file) {
      uploadFile(file, async (err, data) => {
          if (err) {
              console.log(err);
          } else {
              this.videoFiles = [];
              console.log(data, "data");
              let fileData = JSON.parse(JSON.stringify(data));
              var au = document.createElement("audio");
              au.src = data.fid;
              this.loading = false;
              fileData.url = data.fid;
              fileData.file = data.fid;
              fileData.md5 = file.md5;
              fileData.type = file.type;
              fileData.name = file.name;
              fileData.size = file.size;
              fileData.status = "success";
              this.videoFiles.push(fileData);
              console.log(this.videoFiles, "this.data.files");
          }
      });
    },
    del() {
        document.getElementById("file-selector").value = "";
        // this.fomData.files=[]
    },
    //  预览音频文件
    viewMaterial(name,url) {
        var _this = this;
        myLayer.open({
            type: 2,
            title: false,
            shadeClose: true,
            closeBtn: 0, //不显示关闭按钮
            area: ["981px", "550px"],
            content:
            _this.adminPath +
            "/material/preview?name=" +
            name +
            "&type=audio" +
            "&url=" +
            url,
            success: function () {},
        });
    },
  }
};
</script>

<style lang="scss" >
.page-system-set {
  .xc-form-item-label {
    width: 220px;
  }
}
.type-title {
  margin-bottom: 5px;
}

.fault {
  max-width: 880px;
  .fault-wrap {
    width: 90px !important;
  }
  .but-list {
    flex: 1;
    display: flex;
    flex-wrap: wrap;
  }
  .fault-type {
    display: flex;
    align-items: center;
    height: 26px;
    border-radius: 8px;
    border: 1px solid #507dde;
    margin-right: 7px;
    margin-bottom: 7px;
    font-size: 12px;
    color: #507dde;
    .fault-type-left {
      height: 100%;
      line-height: 24px;
      padding: 0 13px;
      border-right: 1px solid #507dde;
    }
    .fault-type-right {
      width: 22px;
      height: 100%;
      line-height: 22px;
      text-align: center;
      font-size: 12px;
      cursor: pointer;
    }
  }
}
.select-style{
  .el-input--suffix{
    width:160px;
    .el-input__inner{
      height:30px;
    }
  }
  .el-icon-arrow-down{
    &:before {
      content: "\e71f";
    }
  }
  .el-cascader .el-input .el-icon-arrow-down.is-reverse{
    transform: none;
  }
}

.page-system-set .game-style{
  width:390px;
  .xc-form-item-label{
    width:160px;
  }
  .xc-form-item-content{
    display: flex;
    .input-width{
      width:auto;
      flex:1;
    }
  }
}

.position-upload {
  position: relative;
}
.file-input {
  position: absolute;
  top: 0;
  min-height: 40px;
  opacity: 0;
}

</style>

